export default __webpack_public_path__ + "static/media/assessment_blue_icon.357f58d4.svg";